import axios from "axios";
import { Message } from "element-ui";
import md5 from "@/utils/md5";
import { requestLoadingState } from "@/utils/requestLoading";

const random = Math.random().toString(36).substr(2);
const signSource = `app_id=cqskurrqogaoclsumenr&app_key=lDExuywpBznIDhGEzbrolIsJDggaeszE&random=${random}`;
const sign = md5.hex_md5(signSource).toUpperCase();

const service = axios.create({
  baseURL: process.env.NODE_ENV === "development" ? "" : process.env.VUE_APP_BASE_URL,
  //baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 30 * 1000,
  withCredentials: true
});

let pendingRequestCount = 0;
let loadingTimer = null;

function showRequestLoading() {
  pendingRequestCount += 1;
  if (loadingTimer) {
    return;
  }
  loadingTimer = window.setTimeout(() => {
    requestLoadingState.visible = true;
  }, 120);
}

function hideRequestLoading() {
  pendingRequestCount = Math.max(pendingRequestCount - 1, 0);
  if (pendingRequestCount > 0) {
    return;
  }
  if (loadingTimer) {
    window.clearTimeout(loadingTimer);
    loadingTimer = null;
  }
  requestLoadingState.visible = false;
}

service.interceptors.request.use(
  (config) => {
    showRequestLoading();
    config.headers = {
      ...config.headers,
      "Content-Type": "application/json",
      random,
      sign,
      Authorization: localStorage.getItem("accessToken") || ""
    };

    return config;
  },
  (error) => {
    hideRequestLoading();
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    hideRequestLoading();
    const { data } = response;

    if (data.code === 401 || (data.code === 400 && data.message === "登录超时")) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("userInfo");
      Message.error("登录超时");
      return Promise.reject(data);
    }

    if (data.code === 400) {
      Message.error(data.message);
      return Promise.reject(data);
    }

    return data;
  },
  (error) => {
    hideRequestLoading();
    const messageMap = {
      400: "错误请求",
      401: "未授权，请重新登录",
      403: "拒绝访问",
      404: "请求错误，未找到该资源",
      405: "请求方法未允许",
      408: "请求超时",
      500: "服务器端出错",
      501: "网络未实现",
      502: "网络错误",
      503: "服务不可用",
      504: "网络超时",
      505: "HTTP 版本不支持该请求"
    };
    const status = error.response && error.response.status;

    error.message = status ? messageMap[status] || `连接错误${status}` : "连接服务器失败";
    Message.error(error.message);

    return Promise.reject(error);
  }
);

export default service;
